import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SidebarWrapper } from "./styled"; // your styled component
import { Box, LazyImage, SpanStyled } from "../Styled/Elements";
import { Cancel, Hamburger, LogoEn, LogoAr, SearchIcon } from "../Styled/AllImages";
import FloatingInput from "../Styled/inputFields/FloatingInput";
import { useTranslation } from "react-i18next";

const Sidebar = ({ data, selectedTutorial, onSelect, sidebarStatus, setSidebarStatus }) => {
  const { t, i18n: {language} } = useTranslation();
  const location = useLocation();
  const sidebarRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    // const handleOutsideClick = (e) => {
    //   if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
    //     setSidebarStatus(false);
    //   }
    // };
    // document.addEventListener("mousedown", handleOutsideClick);
    // return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const filteredData = data?.filter((item) =>
    item?.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <SidebarWrapper
        className={`SideBar ${sidebarStatus ? "open" : "close"}`}
        ref={sidebarRef}
      >
        <Box className="text-center">
          <Box className="logo-container d-flex justify-content-between align-items-center">
            <Link to={'/'}>
              <LazyImage src={language === "en" ? LogoEn : LogoAr} />
            </Link>
          </Box>
          <Box className="sidebar-list custom-scroll">
            <Box className="p-3">
              <FloatingInput
                type="input"
                fieldType="text"
                name={"search"}
                placeholder={t("search")}
                icon={SearchIcon}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Box>
            <ul className="list-unstyled mb-0 pt-3">
              {filteredData?.map((item, key) => {
                const active =
                  selectedTutorial?.id === item?.id ? "active" : "";
                return (
                  <li key={item?.title + key} className="mb-2">
                    <Box
                      className={`text-decoration-none sidebar-item d-flex align-items-center ${active}`}
                      onClick={() => {
                        onSelect(item);
                        setSidebarStatus(false);
                      }}
                    >
                      <SpanStyled
                        className="text-capitalize d-flex"
                        style={{ textAlign: "start" }}
                      >
                        {item?.title}
                      </SpanStyled>
                    </Box>
                  </li>
                );
              })}
            </ul>
          </Box>
        </Box>
      </SidebarWrapper>
    </>
  );
};

export default Sidebar;
